import joinParts from './joinParts';

// The server stores the declaration type (2 characters, e.g. EX) and the additional declaration
// type (1 character, e.g. A) as one `typeCode`. Either part can be missing in a draft or template.
const DECLARATION_TYPE_LENGTH = 2;

export const joinTypeCode = (declarationType?: string | null, additionalType?: string | null) =>
    joinParts(declarationType, additionalType);

export const splitTypeCode = (code?: string | null) => {
    if (!code) return { typeCode: undefined, additionalTypeCode: undefined };

    // A declaration type is always 2 characters, so a shorter code holds the additional type only.
    if (code.length < DECLARATION_TYPE_LENGTH) return { typeCode: undefined, additionalTypeCode: code };

    return {
        typeCode: code.substring(0, DECLARATION_TYPE_LENGTH),
        additionalTypeCode: code.substring(DECLARATION_TYPE_LENGTH) || undefined,
    };
};
